import React from "react";
import { CardThemes } from "../../molecules/Card/Card.types";

export enum ModalTypes {
  warning = "warning",
  celebrate = "celebrate",
}

export interface ModalProps {
  show: boolean;
  handleClose: () => void;
  children: React.ReactNode;
  type?: ModalTypes | CardThemes;
  title?: string;
  loading?: boolean;
  showConfirm?: boolean;
  confirmChildren?: React.ReactNode;
  loadingChildren?: React.ReactNode;
}
